export const useNavigationLoading = () => {
  const isNavigating = ref(false)
  const router = useRouter()
  let navigationStartTime = 0

  const setNavigating = (value: boolean) => {
    if (value === true) {
      navigationStartTime = Date.now()
    }
    isNavigating.value = value
  }

  // Watch for route changes to hide loading
  watch(
    () => router.currentRoute.value.path,
    () => {
      // Ensure loading shows for at least 500ms
      const elapsed = Date.now() - navigationStartTime
      const remainingTime = Math.max(500 - elapsed, 100)

      setTimeout(() => {
        isNavigating.value = false
      }, remainingTime)
    }
  )

  return {
    isNavigating,
    setNavigating
  }
}
